import { Card, Flex } from '@mantine/core';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/elements/Button';
import DataTable from '../../components/elements/DataTable';
import Text from '../../components/fields/Text';
import AreaFilter from '../../components/fragments/AreaFilter';
import ModalConfirmActivationGIGR from '../../components/fragments/ModalConfimActivationGIGR';
import IconCircleArrowUpFilled from '../../components/icons/IconCircleArrowUpFilled';
import IconTools from '../../components/icons/IconTools';
import { AppContext } from '../../contexts';
import { useDebounce } from '../../utils/hooks';
import { fetchMerchantList, fetchUpdateMerchantStatus } from './actions';
import EmptyState from '../../components/fragments/EmptyState/index.jsx';
import styles from './styles.scoped.css';

export default function GIGRActivation() {
  const { setBreadcrumbs } = useContext(AppContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const {
    dataMerchantList, isLoadingMerchantList,
    isLoadingUpdateMerchantStatus, dataUpdateMerchantStatus,
    table: { filter }
  } = useSelector((state) => state?.gigrActivation);
  const {
    dataDetailUser: { regionalId },
  } = useSelector((state) => state.pageBase);
  const [search, setSearch] = useState('');
  const [modalConfirmation, setModalConfirmation] = useState({
    opened: false,
    registrationId: null
  });
  const inputRef = useRef(null);
  const debouncedSearch = useDebounce(search, 1000);
  const params = {
    page: page,
    size: 100,
    regional: filter?.regional,
  };
  const totalPage = dataMerchantList?.meta?.totalPage || 0;
  const isFilterReady = (filter?.regional?.length > 0) || !regionalId;

  const buildMerchantListParams = (currentPage) => ({
    ...params,
    page: currentPage,
    search: debouncedSearch,
    regional: filter?.regional,
    provinceId: filter?.provinceId,
    cityId: filter?.cityId,
    districtId: filter?.districtId,
    villageId: filter?.villageId,
    agenId: filter?.agenId,
  });

  useEffect(() => {
    setBreadcrumbs(['Aktivasi GI/GR']);
    // dispatch(fetchMerchantList(params));
    // console.log('disini');
  }, []);

  useEffect(() => {
    if (isFilterReady) {
      setPage(1);
      dispatch(fetchMerchantList(buildMerchantListParams(1)));
    }
  }, [filter, debouncedSearch]);

  useEffect(() => {
    if (page > 1 && page <= totalPage && isFilterReady) {
      dispatch(fetchMerchantList(buildMerchantListParams(page)));
    }
  }, [page, totalPage, isFilterReady]);

  useEffect(() => {
    if (dataUpdateMerchantStatus && dataUpdateMerchantStatus.success
      && !isLoadingUpdateMerchantStatus) {
      dispatch(fetchMerchantList(params));
    }
  }, [dataUpdateMerchantStatus, isLoadingUpdateMerchantStatus]);

  const columns = [
    {
      heading: 'ID Pangkalan',
      value: 'registrationId',
    }, {
      heading: 'Nama Pangkalan',
      value: 'name'
    }, {
      heading: 'Agen',
      value: ({ agenId, agenName }) => <span>{agenId} - {agenName}</span>
    }, {
      heading: 'Provinsi',
      value: 'provinceName'
    }, {
      heading: 'Kota/Kecamatan',
      value: 'cityName'
    }, {
      heading: 'Kecamatan',
      value: 'districtName'
    }, {
      heading: 'Ubah Status',
      value: ({ registrationId }) => (
        <Button onClick={() => _handleActivation(registrationId)} outlined={true} size={'small'}>Nonaktifkan</Button>
      )
    }
  ];

  const _handleActivation = (registrationId) => {
    setModalConfirmation({
      opened: true,
      registrationId: registrationId
    });
  };

  const _handleClose = () => {
    setModalConfirmation({
      opened: false,
      registrationId: null
    });
  };

  const _handleDeactive = () => {
    dispatch(fetchUpdateMerchantStatus(modalConfirmation.registrationId, { status: 0 }));
    _handleClose();
  };

  return (
    <React.Fragment>
      <AreaFilter />
      <Card my={12} p={20} radius={5} withBorder>
        <Flex align="center" justify="space-between">
          <Flex gap={10}>
            <Button className={styles.btnIcon} onClick={() => navigate('/gigr-activation/activation-by-merchant')}>
              <IconTools /> Aktivasi Per Pangkalan
            </Button>
            <Button className={styles.btnIcon} onClick={() => navigate('/gigr-activation/activation-bulk')}>
              <IconCircleArrowUpFilled /> Aktivasi Dengan File
            </Button>
          </Flex>
          <Text
            className={styles['search-bar']}
            disabled={isLoadingMerchantList}
            hideLabel
            inputProps={{
              ref: inputRef,
              placeholder: 'Cari data...',
              value: search,
              icon: 'ic-search.svg',
              onChange: (e) => setSearch(e.target.value),
            }}
          />
        </Flex>
      </Card>
      {!isLoadingMerchantList && dataMerchantList?.data?.length === 0 ? (
        <Card p={30}>
          <EmptyState desc={'Tambahkan daftar pangkalan'} title="Belum ada pangkalan dengan menu GI/GR aktif" />
        </Card>
      ) : (
        <DataTable
          column={columns}
          data={dataMerchantList.data}
          meta={dataMerchantList.meta}
          onEndReached={() => {
            setPage((prev) => prev + 1);
          }
          } />
      )}
      <ModalConfirmActivationGIGR
        onClose={() => _handleClose()}
        onConfirm={() => _handleDeactive()}
        opened={modalConfirmation.opened}
        registrationId={modalConfirmation.registrationId}
      />
    </React.Fragment>
  );
}
